import styles from "./sidebar.module.css";
import {
  Ballot,
  Lock,
  LockOpen,
  Dashboard,
  Contacts,
  Assignment,
  AssignmentLateSharp,
  People,
  Person,
  ViewHeadlineSharp,
  PollSharp,
  TrackChanges,
  Business,
  HistorySharp,
  Telegram,
  CloudDownloadSharp,
  CopyAll,
  AppRegistration,
  AdminPanelSettings
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import CSVGenerator from "@components/CSVGenerator";
import { rndLogoInstance } from '@components/Globals';
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import SpinnerModal from '@components/SpinnerModal';
import { Divider } from "@mui/material";

function parseJwt(token) {
  const base64Payload = token.split('.')[1];
  const payload = atob(base64Payload);
  return JSON.parse(payload.toString());
}

export default function Sidebar() {

  const [loading, setLoading] = useState(false);
  const [loadingB, setLoadingB] = useState(false);
  const [expandedFieldwork, setExpandedFieldwork] = useState(false);
  const [expandedUserManagement, setExpandedUserManagement] = useState(false);
  const [expandedPermissionsManagement, setExpandedPermissionsManagement] = useState(false);
  const [expandedSystemAdministration, setExpandedSystemAdministration] = useState(false);
  const [administratorRole, setAdministratorRole] = useState(false);
  const [projectManagerRole, setProjectManagerRole] = useState(false);
  let bearer = localStorage.getItem('Bearer');

  if (!bearer) {
    window.location = "/login";

  }

  const payload = parseJwt(bearer);
  const username = payload.name;
  const userId = payload.user_id;

  useEffect(() => {
    setLoading(true);
    // Replace with your data fetching logic
    async function fetchData() {
      try {
        await (async () => {
          const userRoles = await RolePermissionManagementService.getRdiUserRoles(userId);
          const administratorRole = userRoles.some(userRole => (userRole.role.name === 'ADMINISTRATOR'));
          const projectManagerRole = userRoles.some(userRole => (userRole.role.name === 'PROJECT MANAGER'));
          setAdministratorRole(administratorRole);
          setProjectManagerRole(projectManagerRole);
        })([]);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [userId]);

  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarWrapper}>
        <div >
          <span className={styles.logo}>
            <img src={rndLogoInstance} className={styles.hsrc__logo} alt="hsrc logo" />
          </span>
        </div>
        <Divider />
        <div className={styles.avatar}>
          <Person />

          <span>{username} </span>
        </div>

        <Divider />

        <div className={styles.sidebarMenu}>
          <ul className="sidebarList">
            <Link to="/researcherdashboard/overview" className="link">
              <li className={styles.sidebarListItem}>
                <Dashboard className={styles.sidebarIcon} />
                Dashboard Overview
              </li>
            </Link>

            <Link to="/researcherdashboard/despatch" className="link">
              <li className={styles.sidebarListItem}>
                <Telegram className={styles.sidebarIcon} />
                Record Despatch
              </li>
            </Link>

            <Link to="/researcherdashboard/datacapture" className="link">
              <li className={styles.sidebarListItem}>
                <Assignment className={styles.sidebarIcon} />
                Data Capture
              </li>
            </Link>

            <Link to="/researcherdashboard/dataupdate" className="link">
              <li className={styles.sidebarListItem}>
                <AssignmentLateSharp className={styles.sidebarIcon} />
                Data Update
              </li>
            </Link>

            <Link className="link" onClick={(evt) => setExpandedFieldwork(!expandedFieldwork)}>
              <li className={styles.sidebarListItem} >
                <ViewHeadlineSharp className={styles.sidebarIconParent} />
                Fieldwork Management
              </li>
            </Link>

            {expandedFieldwork === true
              ? <ul className="sidebarSubList">
                <Link to="/researcherdashboard/fieldworktracking" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <TrackChanges className={styles.sidebarSubIcon} />
                    Fieldwork Tracking
                  </li>
                </Link>
                <Link to="/researcherdashboard/fieldworkreporting" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <PollSharp className={styles.sidebarSubIcon} />
                    Fieldwork Reporting
                  </li>
                </Link>

                <Link className="sublink" onClick={evt => {
                  (async () => {
                    setLoading(true);
                    await CSVGenerator.exportInteractionsReportToXLS(evt);
                    setLoading(false);
                  })([]);
                }}>
                  <li className={styles.sidebarSubListItem}>
                    <CloudDownloadSharp className={styles.sidebarSubIcon} />
                    {(loading === true) ?
                      'Working on it ...'
                      : 'Interactions Report'
                    }
                  </li>
                </Link>

                <Link className="sublink" onClick={evt => {
                  (async () => {
                    setLoadingB(true);
                    await CSVGenerator.exportFieldworkReportToXLS(evt);
                    setLoadingB(false);
                  })([]);
                }}>
                  <li className={styles.sidebarSubListItem}>
                    <CloudDownloadSharp className={styles.sidebarSubIcon} />
                    {(loadingB === true) ?
                      'Working on it ...'
                      : 'New Fieldwork Report'
                    }
                  </li>
                </Link>
              </ul>
              : null
            }

            <Link to="/researcherdashboard/previous-surveys" className="link">
              <li className={styles.sidebarListItem}>
                <HistorySharp className={styles.sidebarIcon} />
                Previous Surveys
              </li>
            </Link>

            <Link to="/researcherdashboard/institutions" className="link">
              <li className={styles.sidebarListItem}>
                <Business className={styles.sidebarIcon} />
                Institutions
              </li>
            </Link>

            <Link className="link" onClick={(evt) => setExpandedUserManagement(!expandedUserManagement)}>
              <li className={styles.sidebarListItem}>
                <Contacts className={styles.sidebarIconParent} />
                User Management
              </li>
            </Link>

            {expandedUserManagement === true
              ? <ul className="sidebarSubList">
                <Link to="/researcherdashboard/manage-respondents" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <People className={styles.sidebarSubIcon} />
                    Respondent Accounts
                  </li>
                </Link>

                <Link to="/researcherdashboard/manage-researchers" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <People className={styles.sidebarSubIcon} />
                    Researcher Accounts
                  </li>
                </Link>
              </ul>
              : null
            }

            {(administratorRole || projectManagerRole) ?
              <Link className="link" onClick={(evt) => setExpandedPermissionsManagement(!expandedPermissionsManagement)}>
                <li className={styles.sidebarListItem}>
                  <LockOpen className={styles.sidebarIconParent} />
                  Roles & Permissions
                </li>
              </Link>
              : null
            }

            {((administratorRole || projectManagerRole) && (expandedPermissionsManagement === true))
              ? <ul className="sidebarSubList">
                <Link to="/researcherdashboard/manage-roles" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <Ballot className={styles.sidebarSubIcon} />
                    Roles Management
                  </li>
                </Link>

                <Link to="/researcherdashboard/manage-permissions" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <Lock className={styles.sidebarSubIcon} />
                    Permissions Management
                  </li>
                </Link>
              </ul>
              : null
            }

            {(administratorRole === true)
              ? <Link className="link" onClick={(evt) => setExpandedSystemAdministration(!expandedSystemAdministration)}>
                <li className={styles.sidebarListItem}>
                  <AdminPanelSettings className={styles.sidebarIcon} />
                  Administration
                </li>
              </Link>
              : null
            }

            {((administratorRole) && (expandedSystemAdministration === true))
              ? <ul className="sidebarSubList">
                <Link to="/researcherdashboard/survey-cycles" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <AppRegistration className={styles.sidebarSubIcon} />
                    Survey Cycles
                  </li>
                </Link>

                <Link to="/researcherdashboard/registers" className="sublink">
                  <li className={styles.sidebarSubListItem}>
                    <CopyAll className={styles.sidebarSubIcon} />
                    Register Copy
                  </li>
                </Link>
              </ul>
              : null
            }

            <Link to="/researcherdashboard/profile" className="link">
              <li className={styles.sidebarListItem}>
                <Person className={styles.sidebarIcon} />
                My Profile
              </li>
            </Link>

            <Link to="/logout" className="link">
              <li className={styles.sidebarListItem}>
                <button className={styles.logout}>Logout</button>
              </li>
            </Link>

          </ul>
        </div>
      </div>
    </div>
  );
}